import React, { useCallback, useEffect, useState } from 'react';
import { Badge, Banner, BlockStack, Card, InlineStack, Spinner, Text } from '@shopify/polaris';
import { rentalsAPI } from '../services/api';
import RentalDetailModal from '../components/RentalDetailModal';
import RentalOverviewCard from '../components/RentalOverviewCard';

const CurrentRentals = () => {
  const [upcoming, setUpcoming] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [selectedRental, setSelectedRental] = useState(null);

  const fetchUpcomingRentals = useCallback(async () => {
    try {
      setLoading(true);
      setError('');
      const response = await rentalsAPI.getCurrent({ view: 'upcoming' });
      setUpcoming(response.data?.upcoming || []);
    } catch (err) {
      setError('Failed to load upcoming rentals');
      console.error('Upcoming rentals error:', err);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchUpcomingRentals();
  }, [fetchUpcomingRentals]);

  if (loading) {
    return (
      <div style={{ maxWidth: 1200, margin: '0 auto', padding: 40, textAlign: 'center' }}>
        <Spinner size="large" />
        <br />
        <Text variant="bodyMd" tone="subdued">Loading upcoming rentals...</Text>
      </div>
    );
  }

  return (
    <div style={{ maxWidth: 1200, margin: '0 auto' }}>
      <BlockStack gap="400">
        <InlineStack align="space-between" blockAlign="center">
          <Text variant="headingLg">Upcoming Rentals</Text>
          <Badge>{upcoming.length}</Badge>
        </InlineStack>

        {error && <Banner tone="critical" onDismiss={() => setError('')}>{error}</Banner>}

        {upcoming.length === 0 ? (
          <Card><Text variant="bodyMd" tone="subdued">No upcoming rentals.</Text></Card>
        ) : (
          <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(min(360px, 100%), 1fr))', gap: 16 }}>
            {upcoming.map((rental) => (
              <RentalOverviewCard
                key={rental.id}
                rental={rental}
                mode="upcoming"
                onView={setSelectedRental}
              />
            ))}
          </div>
        )}

        <RentalDetailModal
          rental={selectedRental}
          open={Boolean(selectedRental)}
          onUpdated={(updated) => { setSelectedRental(updated); fetchUpcomingRentals(); }}
          onClose={() => setSelectedRental(null)}
        />
      </BlockStack>
    </div>
  );
};

export default CurrentRentals;
